import { Snackbar, SnackbarProps } from '@mui/material'
import React from 'react'
import { v4 as uuidv4 } from 'uuid'

interface SnackbarInterface {
  addMessage: (props: SnackbarProps, children?: React.ReactNode) => void
}

interface SnackbarEntry {
  id: string
  props: SnackbarProps
  children?: React.ReactNode
}

const SnackbarContext = React.createContext<SnackbarInterface | null>(null)

export function SnackbarProvider({ children }: React.PropsWithChildren) {
  const [snackbars, setSnackbar] = React.useState<SnackbarEntry[]>([
    {
      id: uuidv4(),
      props: { message: 'TEST1234' },
    },
  ])

  const val = {
    addMessage: function(props: SnackbarProps, children?: React.ReactNode) {
      setSnackbar([
        ...snackbars,
        {
          id: uuidv4(),
          props,
          children,
        },
      ])

      console.log('added snackbar:', snackbars)
    },
  }

  const onClose = (id: string) => {
    setSnackbar(snackbars.filter(item => item.id !== id))
  }

  return (
    <>
      <SnackbarContext.Provider value={val}>{children}</SnackbarContext.Provider>

      {/* look into https://mui.com/material-ui/react-snackbar/#notistack */}
      {snackbars.map(entry => {
        return <Snackbar {...entry.props} key={entry.id} onClose={() => onClose(entry.id)} open={true} autoHideDuration={5000}></Snackbar>
      })}
    </>
  )
}

export function useSnackbar(): SnackbarInterface {
  const context = React.useContext(SnackbarContext)

  if (context === null) {
    throw new Error('useSnackbar must be used within a SnackbarProvider')
  }
  return context
}
